export enum AppBundleType {
  COUPON = 'COUPON',
  DEFAULT = 'DEFAULT',
}
